// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Button from "../actions/Button.res.js";
import * as Offset from "../layout-and-structure/Offset.res.js";
import * as Popover from "./Popover.res.js";
import * as Tooltip from "./Tooltip.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as LegacyIcon from "../images-and-icons/LegacyIcon.res.js";
import * as ReactAria from "react-aria";
import * as TooltipIcon from "./TooltipIcon.res.js";
import * as ReactStately from "../../externals/ReactStately.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactStately$1 from "react-stately";
import * as AnimatedRender from "../../primitives/AnimatedRender.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactDomEventTarget from "../../primitives/ReactDomEventTarget.res.js";
import * as UseResizeObserver from "react-aria/private/utils/useResizeObserver";
let styles = {
  root: {
    "maxWidth-ks0D6T": "maxWidth-xphddl8",
    $$css: "wino-gc:src/resources/overlays/Dialog.res.js:24"
  }
};
let make = React.memo(props => JsxRuntime.jsx("div", {
  children: JsxRuntime.jsx(Offset.make, {
    children: JsxRuntime.jsx(TooltipIcon.make, {
      children: props.content,
      altTriggerRef: props.titleWrapperRef,
      offset: 3
    }),
    top: -0.5
  }),
  style: {
    marginRight: "13px",
    opacity: "0.75",
    transform: "scale(0.9)"
  }
}));
let styles$1 = {
  Section_header: {
    "display-k1xSpc": "display-x78zum5",
    "gap-kOIVth": "gap-x1jnr06f",
    $$css: "wino-gc:src/resources/overlays/Dialog.res.js:95"
  },
  Section_headerHoverable: {
    ":hover_filter-kO95pf": "filter-x1n661ig",
    $$css: "wino-gc:src/resources/overlays/Dialog.res.js:99"
  },
  Section_content: {
    "transition-kmkexE": "transition-x4enhow",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-x1beo9mf",
    "gap-kOIVth": "gap-x14kbac9",
    $$css: "wino-gc:src/resources/overlays/Dialog.res.js:117"
  },
  Section_contentCollapsable: {
    "overflow-kVQacm": "overflow-xb3r6kr",
    $$css: "wino-gc:src/resources/overlays/Dialog.res.js:123"
  },
  Section_contentClipped: {
    "overflow-kVQacm": "overflow-x7giv3",
    "overflowClipMargin-kOmJVX": "overflowClipMargin-xph0obo",
    $$css: "wino-gc:src/resources/overlays/Dialog.res.js:126"
  }
};
function headerStyleProps(hoverable) {
  return Stylex.props(styles$1.Section_header, hoverable ? styles$1.Section_headerHoverable : styles$1.none);
}
function styleContentProps(hidden, collapsable) {
  let defaultMaxHeight = collapsable ? "300px" : "auto";
  let maxHeight = hidden ? "0" : defaultMaxHeight;
  return Stylex.props(styles$1.Section_content, collapsable ? styles$1.Section_contentCollapsable : styles$1.Section_contentClipped, {
    opacity: hidden ? 0 : 1,
    maxHeight: maxHeight
  }, {
    marginBottom: hidden ? `-` + "24px" : "0"
  });
}
let make$1 = React.memo(props => {
  let __defaultCollapsed = props.defaultCollapsed;
  let __collapsable = props.collapsable;
  let tooltip = props.tooltip;
  let title = props.title;
  let collapsable = __collapsable !== undefined ? __collapsable : false;
  let defaultCollapsed = __defaultCollapsed !== undefined ? __defaultCollapsed : false;
  let titleWrapperRef = React.useRef(null);
  let match = React.useState(() => {
    if (defaultCollapsed) {
      return !collapsable;
    } else {
      return true;
    }
  });
  let setOpened = match[1];
  let opened = match[0];
  let match$1 = {
    className: "display-x78zum5 flexDirection-xdt5ytf gap-x1v2ro7d padding-x99s799",
    "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:89"
  };
  let match$2 = headerStyleProps(collapsable);
  let match$3 = {
    className: "backgroundColor-xcv289a alignSelf-xamitd3 flex-x98rzlu height-x28ko6u",
    "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:104"
  };
  let match$4 = {
    className: "color-xbp64b2 font-x1dfh7bg",
    "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:113"
  };
  let match$5 = {
    className: "display-xjp7ctv",
    "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:110"
  };
  let match$6 = styleContentProps(!opened, collapsable);
  return JsxRuntime.jsxs("div", {
    children: [title !== undefined ? JsxRuntime.jsx(Touchable.make, {
      children: JsxRuntime.jsxs("div", {
        children: [collapsable ? JsxRuntime.jsx(LegacyIcon.make, {
          name: opened ? "arrow_down_light" : "arrow_up_light",
          fill: "#25243a",
          size: 13
        }) : null, JsxRuntime.jsxs("div", {
          children: [JsxRuntime.jsx("span", {
            children: title,
            className: match$4.className,
            style: match$4.style
          }), tooltip !== undefined ? JsxRuntime.jsx(make, {
            content: tooltip,
            titleWrapperRef: titleWrapperRef
          }) : null, JsxRuntime.jsx("div", {
            className: match$3.className
          })],
          ref: Primitive_option.some(titleWrapperRef),
          className: match$5.className,
          style: match$5.style
        })],
        className: match$2.className,
        style: match$2.style
      }),
      disabled: !collapsable,
      onPress: param => setOpened(v => !v)
    }) : null, JsxRuntime.jsx("div", {
      children: props.children,
      className: match$6.className,
      style: match$6.style
    })],
    className: match$1.className,
    style: match$1.style
  });
});
let make$2 = React.memo(props => {
  let __titleStartElement = props.titleStartElement;
  let titleStartElement = __titleStartElement !== undefined ? __titleStartElement : null;
  let match = {
    className: "borderBottomColor-x4oigkz borderBottomStyle-x1q0q8m5 borderBottomWidth-xso031l display-x78zum5 gap-x17d4w8g padding-x1ifpib paddingBottom-x1a8lsjc",
    "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:27"
  };
  let match$1 = {
    className: "color-xbp64b2 font-x2gi07y",
    "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:36"
  };
  return JsxRuntime.jsxs("div", {
    children: [JsxRuntime.jsx("span", {
      children: props.title,
      className: match$1.className,
      style: match$1.style
    }), titleStartElement],
    className: match.className,
    style: match.style
  });
});
let make$3 = React.memo(props => {
  let contentRef = React.useRef(null);
  let match = React.useState(() => false);
  let setContentScrollable = match[1];
  let handleScrollable = React.useCallback(() => {
    let domElement = contentRef.current;
    if (!(domElement == null)) {
      return setContentScrollable(param => domElement.scrollHeight > domElement.clientHeight);
    }
  }, [contentRef]);
  React.useLayoutEffect(() => {
    handleScrollable();
  }, [contentRef]);
  UseResizeObserver.useResizeObserver({
    ref: contentRef,
    onResize: handleScrollable
  });
  let onScroll = React.useCallback(event => {
    let domElement = ReactDomEventTarget.toUnsafeDomEventTarget(event.currentTarget);
    let hasReachedBottomScroll = ((domElement.scrollTop | 0) + domElement.clientHeight | 0) >= (domElement.scrollHeight - 10 | 0);
    setContentScrollable(param => !hasReachedBottomScroll);
  }, []);
  let match$1 = {
    className: "display-x78zum5 flexDirection-xdt5ytf gap-x1v2ro7d maxHeight-x114jws4 overflow-xysyzu8 paddingBottom-xx6bls6 paddingTop-xz9dl7a",
    "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:40"
  };
  let match$2 = {
    className: "backgroundImage-xb5kdra backgroundPosition-xyf91em backgroundSize-x124y4om pointerEvents-x47corl bottom-x1ey2m1c height-x18gnavp left-xu96u03 position-x10l6tqk right-x3m8u43 zIndex-x1vjfegm",
    "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:49"
  };
  return JsxRuntime.jsxs("div", {
    children: [JsxRuntime.jsx("div", {
      children: props.children,
      ref: Primitive_option.some(contentRef),
      className: match$1.className,
      style: match$1.style,
      onScroll: onScroll
    }), JsxRuntime.jsx(AnimatedRender.make, {
      children: JsxRuntime.jsx("div", {
        className: match$2.className,
        style: match$2.style
      }),
      displayed: match[0],
      animation: "fade",
      duration: 450
    })],
    style: {
      position: "relative"
    }
  });
});
let make$4 = React.memo(props => {
  let onRequestDiscard = props.onRequestDiscard;
  let onRequestCommit = props.onRequestCommit;
  let match = {
    className: "borderTopColor-x7i6r9d borderTopStyle-x13fuv20 borderTopWidth-x178xt8z display-x78zum5 gap-x17d4w8g justifyContent-x13a6bvl padding-xs0fqhl",
    "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:61"
  };
  return JsxRuntime.jsxs("div", {
    children: [JsxRuntime.jsx(Button.make, {
      label: I18n.t("Discard"),
      size: "small",
      onPress: () => onRequestDiscard()
    }), JsxRuntime.jsx(Button.make, {
      label: props.commitButtonText,
      variant: "solid",
      tone: "success",
      size: "small",
      disabled: props.commitDisabled,
      pending: props.commitLoading,
      onPress: () => onRequestCommit()
    })],
    className: match.className,
    style: match.style
  });
});
function styleProps(selected, disabled, hasLeftSibling, hasRightSibling, hasLeftSiblingSelected, hasRightSiblingSelected) {
  let removeLeftBorder = !hasLeftSibling || !selected || !hasRightSibling && hasLeftSiblingSelected || !hasLeftSibling && hasRightSiblingSelected;
  let removeRightBorder = !hasRightSibling || hasRightSiblingSelected;
  return {
    0: {
      className: "color-xbp64b2 font-xbldpg whiteSpace-xuxw1ft boxSizing-x9f619 borderColor-x1t4mavk borderStyle-x1y0btm7 borderTopStyle-x1ejq31n borderTopWidth-x972fbf borderWidth-xmkeg23 cursor-x1ypdohk transition-xs6vhbf alignItems-x6s0dn4 display-x78zum5 height-x1vqgdyp justifyContent-xl56j7k padding-xxmtint position-x1n2onr6 width-xh8yej3 boxShadow-x14z90uw",
      style: {
        backgroundColor: "#f8f8fb"
      },
      "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:318"
    },
    8: {
      className: "color-xbp64b2 font-xbldpg whiteSpace-xuxw1ft boxSizing-x9f619 borderColor-x1t4mavk borderStyle-x1y0btm7 borderTopStyle-x1ejq31n borderTopWidth-x972fbf borderWidth-xmkeg23 transition-xs6vhbf alignItems-x6s0dn4 display-x78zum5 height-x1vqgdyp justifyContent-xl56j7k padding-xxmtint position-x1n2onr6 width-xh8yej3 fontWeight-x1xlr1w8 backgroundColor-x17suf5r borderBottomStyle-x1sy0etr borderBottomWidth-x1qhh985 borderTopLeftRadius-x1hs5g0s borderTopRightRadius-xbjeahn cursor-xt0e3qv boxShadow-x1wtrbu5",
      "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:318; wino-gc:src/resources/overlays/Dialog.res.js:341"
    },
    4: {
      className: "font-xbldpg whiteSpace-xuxw1ft boxSizing-x9f619 borderColor-x1t4mavk borderStyle-x1y0btm7 borderTopStyle-x1ejq31n borderTopWidth-x972fbf borderWidth-xmkeg23 transition-xs6vhbf alignItems-x6s0dn4 display-x78zum5 height-x1vqgdyp justifyContent-xl56j7k padding-xxmtint position-x1n2onr6 width-xh8yej3 color-x14lhq51 backgroundColor-x1srn7af cursor-xt0e3qv boxShadow-x1wtrbu5",
      style: {
        backgroundColor: "#f8f8fb"
      },
      "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:318; wino-gc:src/resources/overlays/Dialog.res.js:353"
    },
    12: {
      className: "font-xbldpg whiteSpace-xuxw1ft boxSizing-x9f619 borderColor-x1t4mavk borderStyle-x1y0btm7 borderTopStyle-x1ejq31n borderTopWidth-x972fbf borderWidth-xmkeg23 transition-xs6vhbf alignItems-x6s0dn4 display-x78zum5 height-x1vqgdyp justifyContent-xl56j7k padding-xxmtint position-x1n2onr6 width-xh8yej3 fontWeight-x1xlr1w8 borderBottomStyle-x1sy0etr borderBottomWidth-x1qhh985 borderTopLeftRadius-x1hs5g0s borderTopRightRadius-xbjeahn color-x14lhq51 backgroundColor-x1srn7af cursor-xt0e3qv boxShadow-x1wtrbu5",
      "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:318; wino-gc:src/resources/overlays/Dialog.res.js:341; wino-gc:src/resources/overlays/Dialog.res.js:353"
    },
    2: {
      className: "color-xbp64b2 font-xbldpg whiteSpace-xuxw1ft boxSizing-x9f619 borderColor-x1t4mavk borderStyle-x1y0btm7 borderTopStyle-x1ejq31n borderTopWidth-x972fbf borderWidth-xmkeg23 cursor-x1ypdohk transition-xs6vhbf alignItems-x6s0dn4 display-x78zum5 height-x1vqgdyp justifyContent-xl56j7k padding-xxmtint position-x1n2onr6 width-xh8yej3 boxShadow-x14z90uw",
      style: {
        backgroundColor: "#f8f8fb",
        borderLeftStyle: "none",
        borderLeftWidth: "0px"
      },
      "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:318"
    },
    10: {
      className: "color-xbp64b2 font-xbldpg whiteSpace-xuxw1ft boxSizing-x9f619 borderColor-x1t4mavk borderStyle-x1y0btm7 borderTopStyle-x1ejq31n borderTopWidth-x972fbf borderWidth-xmkeg23 transition-xs6vhbf alignItems-x6s0dn4 display-x78zum5 height-x1vqgdyp justifyContent-xl56j7k padding-xxmtint position-x1n2onr6 width-xh8yej3 fontWeight-x1xlr1w8 backgroundColor-x17suf5r borderBottomStyle-x1sy0etr borderBottomWidth-x1qhh985 borderTopLeftRadius-x1hs5g0s borderTopRightRadius-xbjeahn cursor-xt0e3qv boxShadow-x1wtrbu5",
      style: {
        borderLeftStyle: "none",
        borderLeftWidth: "0px"
      },
      "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:318; wino-gc:src/resources/overlays/Dialog.res.js:341"
    },
    6: {
      className: "font-xbldpg whiteSpace-xuxw1ft boxSizing-x9f619 borderColor-x1t4mavk borderStyle-x1y0btm7 borderTopStyle-x1ejq31n borderTopWidth-x972fbf borderWidth-xmkeg23 transition-xs6vhbf alignItems-x6s0dn4 display-x78zum5 height-x1vqgdyp justifyContent-xl56j7k padding-xxmtint position-x1n2onr6 width-xh8yej3 color-x14lhq51 backgroundColor-x1srn7af cursor-xt0e3qv boxShadow-x1wtrbu5",
      style: {
        backgroundColor: "#f8f8fb",
        borderLeftStyle: "none",
        borderLeftWidth: "0px"
      },
      "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:318; wino-gc:src/resources/overlays/Dialog.res.js:353"
    },
    14: {
      className: "font-xbldpg whiteSpace-xuxw1ft boxSizing-x9f619 borderColor-x1t4mavk borderStyle-x1y0btm7 borderTopStyle-x1ejq31n borderTopWidth-x972fbf borderWidth-xmkeg23 transition-xs6vhbf alignItems-x6s0dn4 display-x78zum5 height-x1vqgdyp justifyContent-xl56j7k padding-xxmtint position-x1n2onr6 width-xh8yej3 fontWeight-x1xlr1w8 borderBottomStyle-x1sy0etr borderBottomWidth-x1qhh985 borderTopLeftRadius-x1hs5g0s borderTopRightRadius-xbjeahn color-x14lhq51 backgroundColor-x1srn7af cursor-xt0e3qv boxShadow-x1wtrbu5",
      style: {
        borderLeftStyle: "none",
        borderLeftWidth: "0px"
      },
      "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:318; wino-gc:src/resources/overlays/Dialog.res.js:341; wino-gc:src/resources/overlays/Dialog.res.js:353"
    },
    1: {
      className: "color-xbp64b2 font-xbldpg whiteSpace-xuxw1ft boxSizing-x9f619 borderColor-x1t4mavk borderStyle-x1y0btm7 borderTopStyle-x1ejq31n borderTopWidth-x972fbf borderWidth-xmkeg23 cursor-x1ypdohk transition-xs6vhbf alignItems-x6s0dn4 display-x78zum5 height-x1vqgdyp justifyContent-xl56j7k padding-xxmtint position-x1n2onr6 width-xh8yej3 boxShadow-x14z90uw",
      style: {
        backgroundColor: "#f8f8fb",
        borderRightStyle: "none",
        borderRightWidth: "0px"
      },
      "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:318"
    },
    9: {
      className: "color-xbp64b2 font-xbldpg whiteSpace-xuxw1ft boxSizing-x9f619 borderColor-x1t4mavk borderStyle-x1y0btm7 borderTopStyle-x1ejq31n borderTopWidth-x972fbf borderWidth-xmkeg23 transition-xs6vhbf alignItems-x6s0dn4 display-x78zum5 height-x1vqgdyp justifyContent-xl56j7k padding-xxmtint position-x1n2onr6 width-xh8yej3 fontWeight-x1xlr1w8 backgroundColor-x17suf5r borderBottomStyle-x1sy0etr borderBottomWidth-x1qhh985 borderTopLeftRadius-x1hs5g0s borderTopRightRadius-xbjeahn cursor-xt0e3qv boxShadow-x1wtrbu5",
      style: {
        borderRightStyle: "none",
        borderRightWidth: "0px"
      },
      "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:318; wino-gc:src/resources/overlays/Dialog.res.js:341"
    },
    5: {
      className: "font-xbldpg whiteSpace-xuxw1ft boxSizing-x9f619 borderColor-x1t4mavk borderStyle-x1y0btm7 borderTopStyle-x1ejq31n borderTopWidth-x972fbf borderWidth-xmkeg23 transition-xs6vhbf alignItems-x6s0dn4 display-x78zum5 height-x1vqgdyp justifyContent-xl56j7k padding-xxmtint position-x1n2onr6 width-xh8yej3 color-x14lhq51 backgroundColor-x1srn7af cursor-xt0e3qv boxShadow-x1wtrbu5",
      style: {
        backgroundColor: "#f8f8fb",
        borderRightStyle: "none",
        borderRightWidth: "0px"
      },
      "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:318; wino-gc:src/resources/overlays/Dialog.res.js:353"
    },
    13: {
      className: "font-xbldpg whiteSpace-xuxw1ft boxSizing-x9f619 borderColor-x1t4mavk borderStyle-x1y0btm7 borderTopStyle-x1ejq31n borderTopWidth-x972fbf borderWidth-xmkeg23 transition-xs6vhbf alignItems-x6s0dn4 display-x78zum5 height-x1vqgdyp justifyContent-xl56j7k padding-xxmtint position-x1n2onr6 width-xh8yej3 fontWeight-x1xlr1w8 borderBottomStyle-x1sy0etr borderBottomWidth-x1qhh985 borderTopLeftRadius-x1hs5g0s borderTopRightRadius-xbjeahn color-x14lhq51 backgroundColor-x1srn7af cursor-xt0e3qv boxShadow-x1wtrbu5",
      style: {
        borderRightStyle: "none",
        borderRightWidth: "0px"
      },
      "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:318; wino-gc:src/resources/overlays/Dialog.res.js:341; wino-gc:src/resources/overlays/Dialog.res.js:353"
    },
    3: {
      className: "color-xbp64b2 font-xbldpg whiteSpace-xuxw1ft boxSizing-x9f619 borderColor-x1t4mavk borderStyle-x1y0btm7 borderTopStyle-x1ejq31n borderTopWidth-x972fbf borderWidth-xmkeg23 cursor-x1ypdohk transition-xs6vhbf alignItems-x6s0dn4 display-x78zum5 height-x1vqgdyp justifyContent-xl56j7k padding-xxmtint position-x1n2onr6 width-xh8yej3 boxShadow-x14z90uw",
      style: {
        backgroundColor: "#f8f8fb",
        borderLeftStyle: "none",
        borderLeftWidth: "0px",
        borderRightStyle: "none",
        borderRightWidth: "0px"
      },
      "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:318"
    },
    11: {
      className: "color-xbp64b2 font-xbldpg whiteSpace-xuxw1ft boxSizing-x9f619 borderColor-x1t4mavk borderStyle-x1y0btm7 borderTopStyle-x1ejq31n borderTopWidth-x972fbf borderWidth-xmkeg23 transition-xs6vhbf alignItems-x6s0dn4 display-x78zum5 height-x1vqgdyp justifyContent-xl56j7k padding-xxmtint position-x1n2onr6 width-xh8yej3 fontWeight-x1xlr1w8 backgroundColor-x17suf5r borderBottomStyle-x1sy0etr borderBottomWidth-x1qhh985 borderTopLeftRadius-x1hs5g0s borderTopRightRadius-xbjeahn cursor-xt0e3qv boxShadow-x1wtrbu5",
      style: {
        borderLeftStyle: "none",
        borderLeftWidth: "0px",
        borderRightStyle: "none",
        borderRightWidth: "0px"
      },
      "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:318; wino-gc:src/resources/overlays/Dialog.res.js:341"
    },
    7: {
      className: "font-xbldpg whiteSpace-xuxw1ft boxSizing-x9f619 borderColor-x1t4mavk borderStyle-x1y0btm7 borderTopStyle-x1ejq31n borderTopWidth-x972fbf borderWidth-xmkeg23 transition-xs6vhbf alignItems-x6s0dn4 display-x78zum5 height-x1vqgdyp justifyContent-xl56j7k padding-xxmtint position-x1n2onr6 width-xh8yej3 color-x14lhq51 backgroundColor-x1srn7af cursor-xt0e3qv boxShadow-x1wtrbu5",
      style: {
        backgroundColor: "#f8f8fb",
        borderLeftStyle: "none",
        borderLeftWidth: "0px",
        borderRightStyle: "none",
        borderRightWidth: "0px"
      },
      "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:318; wino-gc:src/resources/overlays/Dialog.res.js:353"
    },
    15: {
      className: "font-xbldpg whiteSpace-xuxw1ft boxSizing-x9f619 borderColor-x1t4mavk borderStyle-x1y0btm7 borderTopStyle-x1ejq31n borderTopWidth-x972fbf borderWidth-xmkeg23 transition-xs6vhbf alignItems-x6s0dn4 display-x78zum5 height-x1vqgdyp justifyContent-xl56j7k padding-xxmtint position-x1n2onr6 width-xh8yej3 fontWeight-x1xlr1w8 borderBottomStyle-x1sy0etr borderBottomWidth-x1qhh985 borderTopLeftRadius-x1hs5g0s borderTopRightRadius-xbjeahn color-x14lhq51 backgroundColor-x1srn7af cursor-xt0e3qv boxShadow-x1wtrbu5",
      style: {
        borderLeftStyle: "none",
        borderLeftWidth: "0px",
        borderRightStyle: "none",
        borderRightWidth: "0px"
      },
      "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:318; wino-gc:src/resources/overlays/Dialog.res.js:341; wino-gc:src/resources/overlays/Dialog.res.js:353"
    }
  }[!!selected << 3 | !!disabled << 2 | !!removeLeftBorder << 1 | !!removeRightBorder << 0];
}
let make$5 = React.memo(props => {
  let item = props.item;
  let state = props.state;
  let ref = React.useRef(null);
  let match = ReactAria.useTab({
    key: item.key
  }, state, ref);
  let hasLeftSibling = Stdlib_Option.isSome(Primitive_option.fromNullable(item.prevKey));
  let hasRightSibling = Stdlib_Option.isSome(Primitive_option.fromNullable(item.nextKey));
  let hasLeftSiblingSelected = item.prevKey === state.selectedKey;
  let hasRightSiblingSelected = item.nextKey === state.selectedKey;
  let match$1 = styleProps(match.isSelected, match.isDisabled, hasLeftSibling, hasRightSibling, hasLeftSiblingSelected, hasRightSiblingSelected);
  let newrecord = {
    ...match.tabProps
  };
  return JsxRuntime.jsx(ReactAria.FocusScope, {
    children: JsxRuntime.jsx(Tooltip.make, {
      children: JsxRuntime.jsx("div", (newrecord.style = match$1.style, newrecord.className = match$1.className, newrecord.ref = Primitive_option.some(ref), newrecord.children = item.rendered, newrecord)),
      placement: "top start",
      offset: -8,
      content: JsxRuntime.jsx(Tooltip.Span.make, {
        text: Stdlib_Option.getOr(item.props.tooltipText, "")
      }),
      disabled: Stdlib_Option.isNone(item.props.tooltipText),
      grow: true,
      delay: 350
    }),
    restoreFocus: true,
    autoFocus: !hasLeftSibling
  });
});
let make$6 = React.memo(props => {
  let state = props.state;
  let ref = React.useRef(null);
  let match = ReactAria.useTabPanel({
    "aria-describedby": ""
  }, state, ref);
  let tabContent = React.useMemo(() => Stdlib_Option.mapOr(Primitive_option.fromNullable(state.selectedItem), null, item => item.props.children), [state.selectedItem]);
  let newrecord = {
    ...match.tabPanelProps
  };
  return JsxRuntime.jsx("div", (newrecord.ref = Primitive_option.some(ref), newrecord.children = props.render(tabContent), newrecord));
});
let make$7 = React.memo(props => {
  let onChange = props.onChange;
  let props_children = props.items;
  let props_disabledKeys = props.disabledKeys;
  let props_onSelectionChange = key => {
    if (!(key == null) && onChange !== undefined) {
      return onChange(key);
    }
  };
  let props$1 = {
    "aria-label": "popover-dialog-tabs",
    children: props_children,
    disabledKeys: props_disabledKeys,
    onSelectionChange: props_onSelectionChange
  };
  let state = ReactStately$1.useTabListState(props$1);
  let ref = React.useRef(null);
  let match = ReactAria.useTabList(props$1, state, ref);
  let match$1 = {
    className: "backgroundColor-xhb2u9n boxSizing-x9f619 display-x78zum5 flexDirection-x1q0g3np",
    "data-style-src": "wino-gc:src/resources/overlays/Dialog.res.js:312"
  };
  let newrecord = {
    ...match.tabListProps
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx("div", (newrecord.style = match$1.style, newrecord.className = match$1.className, newrecord.ref = Primitive_option.some(ref), newrecord.children = ReactStately.Collection.toArray(state.collection).map(item => JsxRuntime.jsx(make$5, {
      item: item,
      state: state
    }, item.key)), newrecord)), JsxRuntime.jsx(make$6, {
      state: state,
      render: props.children
    }, Stdlib_Option.mapOr(Primitive_option.fromNullable(state.selectedItem), "", item => item.key))]
  });
});
function styleProps$1(width) {
  return Stylex.props(styles.root, width !== undefined ? {
    width: String(Primitive_option.valFromOption(width)) + "px"
  } : {});
}
function Dialog(props) {
  let onRequestDiscard = props.onRequestDiscard;
  let onRequestCommit = props.onRequestCommit;
  let __commitButtonText = props.commitButtonText;
  let __commitLoading = props.commitLoading;
  let __commitDisabled = props.commitDisabled;
  let header = props.header;
  let children = props.children;
  let ariaProps = props.ariaProps;
  let commitDisabled = __commitDisabled !== undefined ? __commitDisabled : false;
  let commitLoading = __commitLoading !== undefined ? __commitLoading : false;
  let commitButtonText = __commitButtonText !== undefined ? __commitButtonText : I18n.t("Save");
  let onKeyDown = React.useCallback(event => {
    let ctrlKeyPressed = event.ctrlKey;
    let match = event.key;
    if (match === "Enter" && ctrlKeyPressed && !commitDisabled) {
      onRequestCommit();
      event.preventDefault();
      return;
    }
  }, [onRequestCommit, commitDisabled]);
  React.useEffect(() => {
    let document = globalThis.document;
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [onKeyDown]);
  let match = styleProps$1(props.width);
  let style = match.style;
  let className = match.className;
  if (header.TAG === "Title") {
    let match$1 = header._0;
    let title = match$1.text;
    return JsxRuntime.jsxs(Popover.Dialog.make, {
      children: [JsxRuntime.jsx(make$2, {
        title: title,
        titleStartElement: match$1.titleStartElement
      }), JsxRuntime.jsx(make$3, {
        children: children
      }), JsxRuntime.jsx(make$4, {
        commitButtonText: commitButtonText,
        commitLoading: commitLoading,
        commitDisabled: commitDisabled,
        onRequestCommit: onRequestCommit,
        onRequestDiscard: onRequestDiscard
      })],
      ariaLabel: title,
      ariaProps: ariaProps,
      style: style,
      className: className
    });
  }
  let match$2 = header._0;
  return JsxRuntime.jsx(Popover.Dialog.make, {
    children: JsxRuntime.jsx(make$7, {
      children: tabContent => JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [JsxRuntime.jsx(make$3, {
          children: tabContent
        }), JsxRuntime.jsx(make$4, {
          commitButtonText: commitButtonText,
          commitLoading: commitLoading,
          commitDisabled: commitDisabled,
          onRequestCommit: onRequestCommit,
          onRequestDiscard: onRequestDiscard
        })]
      }),
      items: children,
      disabledKeys: match$2.disabledKeys,
      onChange: match$2.onChange
    }),
    ariaProps: ariaProps,
    style: style,
    className: className
  });
}
let make$8 = React.memo(Dialog);
let Section = {
  make: make$1
};
let Tab;
export { Section, Tab, make$8 as make };
/* styles Not a pure module */